import { render } from "./BrandAbout.vue?vue&type=template&id=1a5e1374"
import script from "./BrandAbout.vue?vue&type=script&lang=js"
export * from "./BrandAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__